import React, {useEffect} from "react";
import Swiper, {Autoplay} from "swiper";
import 'swiper/css';

import isMobile from "ismobilejs";

//Images
import TitleBG from "../images/background-02.jpg";
import TitleBGRet from "../images/background-02@2x.jpg";
import TitleBGWebp from "../images/background-02.webp";
import TitleBGWebpRet from "../images/background-02@2x.webp";

import src01 from "../images/image2_1-01.jpg";
import src01Ret from "../images/image2_1-01@2x.jpg";
import webp01 from "../images/image2_1-01.webp";
import webp01Ret from "../images/image2_1-01@2x.webp";

import src02 from "../images/image2_1-02.jpg";
import src02Ret from "../images/image2_1-02@2x.jpg";
import webp02 from "../images/image2_1-02.webp";
import webp02Ret from "../images/image1_2-02@2x.webp";

import src03 from "../images/image2_2-01.jpg";
import src03Ret from "../images/image2_2-01@2x.jpg";
import webp03 from "../images/image2_2-01.webp";
import webp03Ret from "../images/image2_2-01@2x.webp";

import src04 from "../images/image2_3-01.jpg";
import src04Ret from "../images/image2_3-01@2x.jpg";
import webp04 from "../images/image2_3-01.webp";
import webp04Ret from "../images/image2_3-01@2x.webp";

import src05 from "../images/image2_3-02.jpg";
import src05Ret from "../images/image2_3-02@2x.jpg";
import webp05 from "../images/image2_3-02.webp";
import webp05Ret from "../images/image2_3-02@2x.webp";

import Content from "./Elements/Content";
import Title from "./Elements/Title";
import Block from "./Elements/Block";

import styles from './Section02.module.scss';
import Highlight from "./Elements/Highlight";
import ImageText from "./Elements/ImageText";
import MutationRemote from "./Graph/MutationRemote";
import InterestRemote from "./Graph/InterestRemote";
import ToolsRemote from "./Graph/ToolsRemote";
import CloudMarket from "./Graph/CloudMarket";


export default function Section02() {
    const sectionTitle = `Les acteurs d’un nouveau monde du travail virtuel`;

    useEffect(() => {
        if (isMobile().phone) {
            new Swiper('.swiper', {
                modules: [Autoplay],
                slidesPerView: 1,
                spaceBetween: 3,
                autoplay: {
                    delay: 1000
                }
            });
        }
    }, []);

    const tableData = {
        thead: ['Company', '2021 Shipments', '2021 Market Share', '2020 Shipments', '2020 Market Share', '2021/2020 Growth'],
        tbody: [
            ['Lenovo', '81,935', '23,5%', '71,832', '23,6%', '14,1%'],
            ['HP Inc.', '74,104', '21,2%', '67,782', '22,3%', '9,3%'],
            ['Dell Technologies', '59,303', '17,0%', '50,297', '16,6%', '17,9%'],
            ['Apple', '27,775', '8,0%', '22,754', '7,5%', '22,1%'],
            ['Acer Group', '23,906', '6,9%', '20,977', '6,9%', '14,0%'],
            ['Others', '81,777', '23,4%', '70,218', '23,1%', '16,5%']
        ],
        tfoot: ['Total', '348,800', '100%', '303,860', '100%', '14,8%']
    };


    return (
        <Content classname={'navigation--1'}>
            <Title title={sectionTitle} numero={2}
                   background={{src: TitleBG, srcRet: TitleBGRet, webp: TitleBGWebp, webpRet: TitleBGWebpRet}}/>

            <Block title={`Explosion des logiciels de communication`} number={2.1} sectionTitle={sectionTitle}
                   container={false}
                   classname={'navigation--2'}>
                <div className="container" style={{zIndex: 2}}>

                    <ImageText image={{src: src01, srcRet: src01Ret, webp: webp01, webpRet: webp01Ret}} radius={true}
                               classname={styles.Image}>
                        <p>
                            Elles s’appellent Zoom, Slack, Teams, Google Meet, Cisco Webex… Ces applications ont connu
                            un succès phénoménal à partir du printemps 2020. Face à l’envolée des cas de contaminations
                            au coronavirus, partout dans le monde, les gouvernements décident de demander aux
                            entreprises de privilégier le télétravail, pour ne pas mettre en péril l’économie. Il faut
                            donc mettre en place des réunions virtuelles, pour faciliter les échanges. Le succès est
                            énorme puisque près de 80% des employés utilisent des outils de collaboration pour le
                            travail en 2021, contre un peu plus de la moitié d’entre eux en 2019, selon une enquête du
                            cabinet Gartner. Il s'agit d'une augmentation de 44% depuis le début de la pandémie.
                        </p>
                    </ImageText>
                </div>

                <Highlight title={'Mutations dans l\'utilisation des technologies numériques au travail'}
                           source={'Pourcentage de répondants à la question « Utilisez-vous ces outils pour votre travail ? », Gartner, août 2021'}
                           color={'pink'}
                           font={'black'} classname={styles.MutationHighlight}>

                    <MutationRemote/>
                </Highlight>

                <div className="container">
                    <h4>
                        Voici les applications les plus <br/>
                        populaires dans le monde.
                    </h4>

                    <ImageText image={{src: src02, srcRet: src02Ret, webp: webp02, webpRet: webp02Ret}} radius={true}
                               classname={[styles.Image, 'sticky--image'].join(' ')}>
                        <p>
                            <strong>
                                ZOOM
                            </strong>

                            <br/><br/>

                            <small>
                                C’est l’application star du confinement. La start-up de visioconférence a vu son
                                activité décoller depuis le début de la pandémie, avec le recours généralisé au
                                télétravail. En 2020, au cœur de la crise sanitaire, les revenus de Zoom ont flambé de…
                                360% ! Depuis, cet emballement est un peu retombé, mais l’entreprise lancée en 2013
                                profite toujours des changements d’organisation dans les entreprises, d’autant que le
                                coronavirus est toujours là. Simple d’utilisation, l’application a su séduire les
                                usagers individuels, mais aussi les entreprises. En additionnant les utilisateurs
                                gratuits et payants, Zoom compte 300 millions de participants à des réunions chaque
                                jour. Cela représente une augmentation de 2.900% par rapport au 31 décembre 2019. Pour
                                fidéliser ses utilisateurs, la société a lancé une variété de nouvelles offres telles
                                qu’une plateforme événementielle, où les entreprises peuvent organiser des conférences à
                                grande échelle, un service d'appel dans le cloud (Zoom Phone) et des réunions au bureau
                                (Zoom Rooms).
                            </small>

                            <br/><br/><br/><br/>

                            <strong>
                                SLACK
                            </strong>

                            <br/><br/>

                            <small>
                                Lancée en 2014, l’application Slack a comme ses concurrentes connu une envolée avec la
                                crise sanitaire, au point d’être rachetée en décembre 2020 par Salesforce, pour la
                                coquette somme de 28 milliards de dollars. L’entreprise a généré 902 millions de dollars
                                de revenus entre mars 2020 et avril 2021, soit une augmentation de 43% d'une année sur
                                l'autre. Slack compte 12 millions d'utilisateurs actifs quotidiens dans le monde, et
                                156.000 organisations sont abonnées à l'application. L’application fonctionne comme un «
                                chat » organisé en canaux correspondant à autant de sujets de discussion. La plateforme
                                permet aussi le partage de fichiers au sein des conversations, qui peuvent être
                                conservées. L’entreprise a embauché environ 50% de ses équipes depuis le début de la
                                pandémie. "Quand je vois des gros titres sur des PDG essayant de faire revenir leurs
                                employés au bureau, j'ai l'impression que c'est une approche vouée à l'échec", a déclaré
                                le patron de Slack, Stewart Butterfield, dans une récente interview. "Le travail n'est
                                plus un endroit où vous allez. C'est quelque chose que vous faites."
                            </small>

                            <br/><br/><br/><br/>

                            <strong>
                                TEAMS
                            </strong>

                            <br/><br/>

                            <small>
                                Conçue en 2016, Teams est la plateforme collaborative intégrée à la suite bureautique
                                Office 365. Son activité a explosé avec la pandémie et les confinements successifs. En
                                mars 2020, l'entreprise comptait 20 millions d'utilisateurs actifs quotidiens, avant de
                                bondir à 145 millions 18 mois plus tard. Contrairement à Slack, utilisé surtout pour sa
                                messagerie, Teams est prisé pour ses solutions de vidéoconférence, et notamment depuis
                                l'intégration de sa messagerie « Skype for Business » à l'application fin 2018. Les
                                salariés, qui utilisaient beaucoup la messagerie de Teams, se sont convertis aux
                                réunions en « visio » avec la pandémie.
                            </small>
                        </p>
                    </ImageText>

                    <Highlight
                        title={'Evolution de l’intérêt pour les recherches <br/> « Teams », « Slack » et « Zoom » en mars 2020 '}
                        source={'Source : Google Trends'} color={'grey'}>

                        <InterestRemote/>
                    </Highlight>

                    <div className={styles.Bubbles}>
                        <strong>
                            « Bulle » sur les principaux <br/> outils de travail collaboratif
                        </strong>

                        <ToolsRemote/>
                    </div>
                </div>
            </Block>

            <Block title={`Outils hard et soft`} number={2.2} sectionTitle={sectionTitle}
                   classname={'navigation--2'}>
                <div className="container">
                    <p className={'size-5 ml-4'}>Le télétravail a poussé de nombreux travailleurs à réadapter leur mode
                        de vie. Pour nombre d’entre eux, il a fallu s'équiper en urgence pour pouvoir correctement
                        travailler à distance. Avec le recours des réunions en ligne par exemple, il faut déjà avoir un
                        ordinateur, mais aussi s'assurer qu'il est équipé d'une webcam avec un micro. Logiquement, les
                        ventes de matériel informatique en particulier ont explosé pendant le confinement en France
                        comme ailleurs dans le monde, faisant bénéficier au passage les fabricants de puces graphiques,
                        tels que Nvidia ou Intel. Dès le second semestre 2020, le marché des ordinateurs portables et
                        des équipements informatiques a connu une forte croissance. En 2021, les ventes de PC ont
                        atteint leur plus haut niveau en 10 ans. Plus de 340 millions d'unités ont été vendues l’an
                        dernier avec Lenovo en tête, dépassant les 300 millions un an plus tôt, selon une étude IDC. Une
                        autre étude de Gartner évoque de son côté une croissance à 9,9 % en 2021. </p>

                    <Highlight
                        title={'Top 5 des entreprises : livraisons mondiales de PC traditionnels, part de marché et croissance d\'une année sur l\'autre, 2021'}
                        source={'Résultats préliminaires, les expéditions sont en milliers d\'unités <br/> IDC, suivi trimestriel des appareils informatiques personnels, janvier 2022'}
                        color={'green'}>


                        <div className={styles.TableWrapper}>
                            {
                                tableData ?
                                    <table className={styles.Table}>
                                        <thead>
                                        <tr>
                                            {tableData.thead.map((item, index) => <th key={index}>{item}</th>)}
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {
                                            tableData.tbody.map((row, rowIndex) =>
                                                <tr key={rowIndex}>
                                                    {
                                                        row.map((item, index) =>
                                                            <td key={index}>
                                                                {
                                                                    index === 0 ? rowIndex + 1 + '. ' : null
                                                                }
                                                                {item}
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                            )
                                        }
                                        </tbody>

                                        <tfoot>
                                        <tr>
                                            {tableData.tfoot.map((item, index) => <th className={[0, 1, 3].includes(index) ? 'bold' : null} key={index}>{item}</th>)}
                                        </tr>
                                        </tfoot>
                                    </table>
                                    : null
                            }
                        </div>
                    </Highlight>

                    <ImageText image={{src: src03, srcRet: src03Ret, webp: webp03, webpRet: webp03Ret}} radius={true}
                               classname={'with--margin-image pl-1'}>
                        <p>En janvier 2022, le cabinet Canalys a également publié un rapport assez encourageant sur l’état du marché des PC. Alors que beaucoup s’attendaient à une chute des livraisons post-déconfinement, c’est le contraire qui s’est produit. « Si 2021 a été l’année de la transformation numérique, 2022 sera l’année de l’accélération numérique », affirme Rushabh Doshi, analyste principal de Canalys. D’après le cabinet Gfk, le marché mondial des équipements high tech grand public a bondi de 17% en un an à 726 milliards de dollars, dopé par la hausse des prix sur fond de pénurie de composants. Avec le recours massif au télétravail, ainsi qu’à l’apprentissage à domicile, le secteur informatique se retrouve en effet confronté à des problèmes d’approvisionnement, les fabricants ont du mal à gérer les commandes face à la forte demande et les consommateurs sont impactés. Selon le PDG d’Intel Pat Gelsinger, il faudra encore quelques années avant que les livraisons ne reprennent à pleine capacité. Le géant américain a annoncé qu’il allait investir 20 milliards de dollars dans deux nouvelles usines en Arizona, aux Etats-Unis. "Mais cela durera quelques années avant d’atteindre la pleine capacité, comme c’est toujours le cas lorsque l’on construit de nouvelles fabriques", a-t-il expliqué.</p>
                    </ImageText>

                    <p className={'size-6 ml-1'}>
                        Pour poursuivre leurs activités dans les meilleures conditions, les télétravailleurs ont également été contraints de numériser des quantités importantes de documents et trouver des outils permettant aux collaborateurs de travailler de chez eux comme s’ils étaient au bureau. Pour ce faire, ils peuvent faire appel à des sociétés spécialisées, ou utiliser une des nombreuses applications. Ces outils se sont d’ailleurs multipliés de façon spectaculaire ces dernières années. Il semble bien loin le temps où tout passait par Skype (Microsoft) : Slack, Teams, WhatsApp, ClickUp, Notion, Happeo, ou encore Zimbra, sont autant de plateformes efficaces et souples pour échanger à distance. "Le gain de temps est énorme", explique un spécialiste des outils en ligne qui souligne que les réunions à distance sont souvent plus courtes que celles en présentielles car les intervenants sont amenés à s'exprimer plus directement et synthétiquement : il convient d'aller droit au but ! Si se rendre au bureau est une perte de temps de plusieurs heures et un non-sens écologique pour ceux qui habitent loin de l'entreprise, il convient cependant de ne pas couper le lien humain avec ses collègues. Les spécialistes soulignent ainsi qu'il peut être utile de passer au bureau deux ou trois jours par mois par exemple, tout en entretenant un lien par le biais d'une réunion ou deux en distancielle par semaine. Car la productivité n'est pas tout, il y a aussi la créativité qui peut être handicapée par la distance et une organisation " déstructurée ". Pour contourner l'obstacle, certains employeurs conseillent à leurs salariés de se rabattre sur des espaces de co-working en complément du temps passé à travailler à domicile...
                    </p>

                    <Highlight color={'yellow'} classname={styles.Tools}>
                        <ul>
                            <li>
                                <h3>
                                    Quelques outils pour la gestion des tâches <br/><br/>
                                </h3>

                                <p>
                                    <strong>Trello</strong>
                                    <small>Outil de gestion de projet en ligne</small>

                                    <strong>Asana</strong>
                                    <small>Outil de gestion de projet</small>

                                    <strong>Jira</strong>
                                    <small>
                                        Système de suivi de bugs, de gestion des incidents et de gestion de projets
                                    </small>

                                    <strong>Monday</strong>
                                    <small>
                                        Outil de gestion d’équipe et de projet, avec un espace de travail virtuel qui permet de gérer les projets et les tâches quotidienne
                                    </small>

                                    <strong>Smartsheet</strong>
                                    <small>
                                        Plateforme basée sur le cloud qui permet de gérer l'exécution des travaux, des projets individuels à la gestion de bout en bout
                                    </small>
                                </p>
                            </li>

                            <li>
                                <h3>
                                    Quelques outils de bureau pour les documents et présentations
                                </h3>

                                <p>
                                    <strong>Google docs</strong>
                                    <small>
                                        Une suite bureautique qui permet de rédiger des lettres et d’éditer des documents professionnels, accessible en ligne et hors-ligne via sa synchronisation avec Google Drive. Il existe également pour les tableurs (Sheets, équivalent d’Excel) et pour les présentations (Slides, équivalent de PowerPoint).
                                    </small>

                                    <strong>Office 365</strong>
                                    <small>La suite Office (Word, Excel, PowerPoint, Outlout, OneNote, Publisher, Access), ainsi qu’un ensemble de service en ligne (OneDrive, Exchange Online…)</small>

                                    <strong>Confluence</strong>
                                    <small>Outil permettant de centraliser et de partager les documents utiles à la préparation des projets ou réunions</small>

                                    <strong>Adobe</strong>
                                    <small>Logiciels d'aide à la création et à la présentation de documents</small>

                                    <strong>Docusign</strong>
                                    <small>Fournit des services électroniques dans le domaine de la gestion des documents</small>
                                </p>
                            </li>

                            <li>
                                <h3>
                                    Quelques outils pour stocker et partager<br/><br/>
                                </h3>

                                <p>
                                    <strong>Dropbox</strong>
                                    <small>Service de stockage et de partage de copies de fichiers locaux en ligne</small>

                                    <strong>WeTransfer</strong>
                                    <small>Service de transfert de fichier fondé
                                        sur le cloud</small>

                                    <strong>GoogleDrive</strong>
                                    <small>Outil permettant de stocker et partager des fichiers dans le cloud avec toute une équipe ou certains membres</small>
                                </p>
                            </li>

                        </ul>
                    </Highlight>
                </div>
            </Block>

            <Block title={`Les maîtres du cloud : Microsoft, OVH...`} number={2.3} sectionTitle={sectionTitle}
                   classname={'navigation--2 pb-0'}>
                <div className="container">
                    <ImageText image={{src: src04, srcRet: src04Ret, webp: webp04, webpRet: webp04Ret}} radius={true}
                               classname={'with--margin rtl'}>
                        <p>La pandémie de coronavirus et les mesures de restrictions qui l’ont accompagnée (couvre-feu, confinements) ont marqué la consécration du cloud informatique. Au troisième trimestre 2021, les dépenses des entreprises en services d'infrastructure cloud ont dépassé la barre des 45 milliards de dollars, en hausse de 37% par rapport au troisième trimestre 2020, montre une étude du cabinet Synergy Research. Sans surprise, les trois leaders mondiaux de ce marché de l'informatique à distance (hébergement et analyse de données, programmation) sont les Américains Amazon, Microsoft et Google. Ils continuent d'attirer bien plus de la moitié des dépenses mondiales des entreprises dans le cloud, avec respectivement 33%, 20% et 10% de parts de marché. La domination est encore plus prononcée dans le cloud public, où le trio contrôle 70% du marché. </p>
                    </ImageText>

                    <ImageText image={{src: src05, srcRet: src05Ret, webp: webp05, webpRet: webp05Ret}} radius={true}
                               classname={'with--margin-image pl-1'}>
                        <p>Cependant, d'autres fournisseurs de cloud continuent d'enregistrer une forte croissance de leurs revenus auprès des entreprises. Alibaba, surtout en Chine, Oracle et IBM sont les suivants sur la liste. Dans le classement mondial, les dix plus grands fournisseurs qui suivent les trois géants ont enregistré une croissance de leurs revenus de 28% en glissement annuel, tandis que celle de la longue liste des fournisseurs de cloud petite à moyenne taille a augmenté de 25%.</p>
                    </ImageText>
                </div>

                <Highlight classname={styles.Cloud} title={'Marché des services d\'infrastructure cloud '} source={'Troisième trimestre 2021, Synergy Research Group'} color={'purple'}>
                    <CloudMarket/>
                </Highlight>
            </Block>
        </Content>
    )
}
